import React from 'react';
import { v4 as uuid } from 'uuid';

const legendNames = {
	coverage_level: 'Nivel cobertura',
	rsrp_level: 'RSRP (dBm)',
	rsrq_level: 'RSRQ (dB)',
	cinr_level: 'CINR (dB)',
};

const MapLegend = ({ legend, metricName }) => {
	return (
		<div className='mapLegend-container'>
			<div className='mapLegend'>
				{legendNames[metricName]}
				{legend.map((item) => (
					<div className='mapLegend-item' key={uuid()}>
						<span
							className='mapLegend-colorbin'
							style={{
								backgroundColor: `rgb(${item.color[0]}, ${item.color[1]}, ${item.color[2]})`,
							}}
						></span>
						<span className='mapLegend-value'>{item.description}</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default MapLegend;
